//export const base_url = "http://localhost:8000/api/v1/";
//export const base_url = "https://preprod.thrundrz.fr/backendpublic/public/api/v1/";
export const base_url = "https://thrundrz.fr/backendpublic/public/api/v1/";
